import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
/** @import { hostResponse, machineResponse } from "~/backend/validate.js"; */

import Button from "~/component/Button.js";
import Dropdown from "~/component/Dropdown.js";
/** @import { DropdownItem } from "~/component/Dropdown.js"; */
import Icon from "~/component/Icon.js";
import util from "~/style/util.js";
import { adopt, CSS_MODULE_SCRIPTS, importCss } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./ComputerCard.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./ComputerCard.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {hostResponse | machineResponse} host
 * @property {ComponentChildren} [connect]
 * @property {DropdownItem[]} [actions]
 * @property {ComponentChildren} [subtitle]
 * @param {Props} props
 */
export default function ComputerCard({
  host,
  connect,
  actions,
  subtitle
}) {
  return __h("div", {
    "class": css.hostCard,
    "data-id": host.id
  }, __h("span", {
    "class": css.icon
  }, __h(Icon, {
    name: host.is_online ? "windows-online" : "windows-offline",
    size: 42
  })), __h("div", {
    "class": css.info
  }, __h("div", {
    "class": css.headline
  }, __h("h2", {
    "class": css.title
  }, host.name), __h("span", {
    "class": css.status,
    "data-online": host.is_online
  }, host.is_online ? "Online" : "Offline")), subtitle ? __h("div", {
    "class": css.hostinfo
  }, subtitle) : null), __h("div", {
    "class": css.right
  }, connect, actions?.length ? __h(Dropdown, {
    id: "host-dropdown-" + host.id,
    placement: "bottom-end",
    trigger: __h(Button, {
      level: "tertiary",
      size: "small",
      popovertarget: "host-dropdown-" + host.id
    }, __h(Icon, {
      name: "menu",
      label: "menu",
      size: 12
    })),
    items: actions
  }) : null));
}

/**
 * @template {hostResponse | machineResponse} T
 * @param {{ hosts: T[]; card: (host: T) => ComponentChildren }} props
 */
export function ComputerList({
  hosts,
  card
}) {
  return __h("ul", {
    "class": css.list
  }, hosts.map(host => __h("li", {
    "class": util.card + " " + css.item,
    key: host.id
  }, card(host))));
}